import { Language, Book } from "../../../rest/models";
import { ModelMap } from "../../../rest/slice";
import { BookTranslationEdit } from "./translation/BookTranslationEdit";

export function BookTranslationsEdit(props: Props)
{
    const {book, langModels, sourceLanguage, sourceTextChanged} = props;
    
    return (
        <div>
            <div>
                We will now translate the book. Here's how to do it.
            </div>
            <ul>
                <li>Click the button below the textbox.</li>
                <li>Wait for the new tab to scroll to the end.</li>
                <li>Wait for Google to finish translating.</li>
                <li>Press the button that says "Copy all text".</li>
                <li>Close the tab.</li>
                <li>Paste the translated text in the text box.</li>
            </ul>

            <p>This needs to be done for both the translation languages and the source language.</p> 

            <label>Translations</label>
            
            {book
                .booklanguage_set
                .map(bl => <BookTranslationEdit
                    key={bl.key}
                    book={book}
                    targetLanguage={langModels[bl.language]}
                    sourceLanguage={langModels[sourceLanguage]}
                    text={bl.translation}
                    sourceTextChanged={sourceTextChanged}/>)}
        </div>);
}

interface Props
{
    book: Book;
    langModels: ModelMap<Language>;
    sourceLanguage: string;
    sourceTextChanged: boolean;
}